import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import OpeningPage from './pages/OpeningPage';
import StartAnalysisPage from './pages/StartAnalysisPage';
import QuestionnairePage from './pages/QuestionnairePage';
import GDPRConsentPage from './pages/GDPRConsentPage';
import CameraPage from './pages/CameraPage';
import ResultsPage from './pages/ResultsPage';
import LanguageSwitcher from './components/LanguageSwitcher';
import './App.css';

function App() {
  return (
    <Router>
      <LanguageSwitcher />
      <ToastContainer position="top-center" autoClose={4000} closeOnClick />
      <Routes>
        <Route path="/" element={<OpeningPage />} />
        <Route path="/start-analysis" element={<StartAnalysisPage />} />
        <Route path="/questionnaire" element={<QuestionnairePage />} />
        <Route path="/gdpr-consent" element={<GDPRConsentPage />} />
        <Route path="/camera" element={<CameraPage />} />
        <Route path="/results" element={<ResultsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
